import isScrolled from './is-scrolled.js';
import A11yDialog from './lib/a11y-dialog-global.js';
import initDutchieCarouselLazy from './dutchie-carousel-lazy.js';

function init() {
	isScrolled();
	initDutchieCarouselLazy();
	// retailerModal();
}
init();

// Get height of site nav
const navEl = document.querySelector('.site-nav');
const withPadding = navEl.clientHeight + 16;
document.querySelector('html').style.setProperty('--nav-height', `${withPadding}px`);


const menuItems = document.querySelectorAll(".site-nav-menu-desktop .menu-item-has-children");

// add aria attributes to nav items
menuItems.forEach(function (el) {
    el.setAttribute('data-expanded', 'false');
    el.querySelector('button').setAttribute('aria-expanded', 'false');
    el.querySelector('.sub-menu').setAttribute('aria-hidden', 'true');
})

let expandedItem = null;

const expandSubMenu = (item) => {
    const subMenu = item.querySelector("ul");
    const button = item.querySelector("button");
    expandedItem = item;

    subMenu.setAttribute("aria-hidden", "false");
    button.setAttribute("aria-expanded", "true");
    item.dataset.expanded = "true";
};

const collapseSubMenu = (item) => {
	if (!item) {
		return;
	}
    const subMenu = item.querySelector("ul");
    const button = item.querySelector("button");
    expandedItem = null;

    subMenu.setAttribute("aria-hidden", "true");
    button.setAttribute("aria-expanded", "false");
    item.dataset.expanded = "false";
};

menuItems.forEach((item) => {
    const button = item.querySelector("button");

    button.addEventListener("click", (event) => {
        if (button.ariaExpanded === "false") {
            expandSubMenu(item);
        } else {
            collapseSubMenu(item);
        }
    });

    item.addEventListener("mouseenter", () => {
        expandSubMenu(item);
    });
    item.addEventListener("mouseleave", () => {
        collapseSubMenu(item);
    });
});

document.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
        if (!expandedItem) {
            return;
        }

        const subMenu = expandedItem.querySelector("ul");

        const focusedElement = expandedItem.querySelector(":focus");
        const firstFocusableElement = expandedItem.querySelector("a");
        const lastFocusableElement = subMenu.lastElementChild.querySelector("a");

        if (!event.shiftKey && focusedElement === lastFocusableElement) {
            collapseSubMenu(expandedItem);
            return;
        }

        if (event.shiftKey && focusedElement === firstFocusableElement) {
            collapseSubMenu(expandedItem);
            return;
        }
    }

    if (event.key == "Escape") {
        collapseSubMenu(expandedItem);
    }
});


const retailerListButtons = document.querySelectorAll(".retailer-list-nav button");
const retailerCards = document.querySelectorAll('.retailer-card');
retailerListButtons.forEach(function (button) {
    
    button.addEventListener("click", (event) => {
        let groupID = button.dataset.retailerGroupToggle;

        document.querySelector(".retailer-list-nav button.active").classList.remove('active');
        button.classList.add('active');

        retailerCards.forEach(function (card) {

            let cardID = card.dataset.retailerCardGroups;

            if (groupID == 'all') {
                card.style.display = '';
                return;
            }

            if(cardID.includes(groupID)) {
                card.style.display = '';
            } else {
                card.style.display = 'none';
            }

        });
    });

});

// 50 50 video modals
document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('.modal').forEach(function(modal) {
        const dialog = new A11yDialog(modal);
        
        const dialogTrigger = document.querySelector('[data-modal-open="'+dialog.id+'"]');
        dialogTrigger.addEventListener('click', function() {
            dialog.show();
        });

        const videoEmbed = modal.querySelector('.embed-container');

        dialog.on('show', function() {
            document.documentElement.style.overflowY = 'hidden';

            if(videoEmbed) {
                const html = videoEmbed.dataset.videoEmbed;
                videoEmbed.innerHTML = html;
            }
        });

        dialog.on('hide', function() {
            document.documentElement.style.overflowY = '';

            if(videoEmbed) {
                videoEmbed.innerHTML = '';
            }
        });
    });
});

const searchModalEl = document.querySelector('#search-modal');
if (searchModalEl) {
	let cpSearchModal = new A11yDialog(searchModalEl);
}

const pushLiftedEvent = (eventName, payload = {}) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: eventName,
		lifted_page_path: `${window.location.pathname}${window.location.search}`,
		...payload,
	});
};

const getStoredLocationContext = () => {
	const getCookieValue = (name) => {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) {
			return parts.pop().split(';').shift() || '';
		}
		return '';
	};

	return {
		lifted_location_id: getCookieValue('retailerID') || '',
		lifted_location_name: localStorage.getItem('cp_retailer_name') || '',
		lifted_menu_type: localStorage.getItem('cp_retailer_menu_type') || getCookieValue('menu_type') || '',
	};
};

const getModuleRoot = (element) => {
	let current = element;
	while (current && current !== document.body) {
		if (current.classList && [...current.classList].some((className) => className.startsWith('module-'))) {
			return current;
		}
		current = current.parentElement;
	}
	return null;
};

const getModuleName = (moduleEl) => {
	if (!moduleEl) {
		return '';
	}

	if (moduleEl.dataset.moduleName) {
		return moduleEl.dataset.moduleName;
	}

	const ignored = new Set(['module-slider', 'module-content', 'module-buttons', 'module-hero']);
	const match = [...moduleEl.classList].find((className) => className.startsWith('module-') && !ignored.has(className));
	return match ? match.replace('module-', '') : 'module';
};

document.addEventListener('click', function (event) {
	const btnEl = event.target.closest('.btn');
	if (!btnEl) {
		return;
	}

	if (btnEl.closest('.module-slider')) {
		return;
	}

	const moduleRoot = getModuleRoot(btnEl);
	if (!moduleRoot || moduleRoot.closest('header, footer, .sitewide-notice, .site-nav, .search-modal')) {
		return;
	}

	const moduleRoots = [...document.querySelectorAll('[class*="module-"]')].filter((el) => getModuleRoot(el) === el);
	const modulePosition = moduleRoots.indexOf(moduleRoot) + 1;
	const locationContext = getStoredLocationContext();
	const linkEl = btnEl.closest('a');

	pushLiftedEvent('lifted_module_click_cta', {
		lifted_component: getModuleName(moduleRoot),
		lifted_action: 'click_cta',
		lifted_module_position: modulePosition > 0 ? modulePosition : 0,
		lifted_label: btnEl.textContent ? btnEl.textContent.trim() : '',
		lifted_target_url: linkEl ? (linkEl.href || '') : '',
		lifted_target: linkEl ? (linkEl.target || '_self') : '_self',
		...locationContext,
	});
});

// site notice
document.querySelectorAll('.sitewide-notice').forEach(function(notice) {
    var hash = notice.getAttribute('data-sitewide-notice');

    var hidden = localStorage.getItem('cp_sitewide_notice_' + hash);
    if (!hidden) {
        notice.style.display = '';
    }

    var closeButton = notice.querySelector('.sitewide-notice-close');
    closeButton.addEventListener('click', function() {
        notice.style.display = 'none';
        localStorage.setItem('cp_sitewide_notice_' + hash, true);
    });
});
// Hide decorative SVGs inside labeled interactive controls from assistive tech.
// Only hide when the control already has an accessible name from text/aria/sr-only.
document.querySelectorAll("button svg, a svg, [aria-label] svg").forEach((svg) => {
    if (svg.getAttribute("role") === "img" || svg.hasAttribute("aria-label") || svg.hasAttribute("aria-labelledby")) {
        return;
    }

    const control = svg.closest("button, a");
    if (control) {
        const hasName = Boolean(
            control.getAttribute("aria-label")
            || control.getAttribute("aria-labelledby")
            || (control.textContent || "").trim()
            || control.querySelector(".sr-only, .screen-reader-text")
        );
        if (!hasName) {
            return;
        }
    }

    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    if (!svg.hasAttribute("role")) {
        svg.setAttribute("role", "presentation");
    }
});
